import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import LoadingButton from 'components/loading-button'
import React from 'react'

const DeleteGuardianDialog = ({
  guardian,
  open,
  onClose,
  onDelete,
  loading,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete Guardian</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete the guardian{' '}
          <strong>
            {guardian?.contact.firstName} {guardian?.contact.lastName}
          </strong>
          ?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <LoadingButton
          onClick={onDelete}
          variant="contained"
          style={{
            backgroundColor: '#d32f2f',
            color: '#fff',
          }}
          loading={loading}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteGuardianDialog
